import type { GroupsPackage } from "@/lib/groups/packages";
import styles from "./packages-gallery.module.css";

interface PackageCitiesProps {
  cities: GroupsPackage["cities"];
}

/**
 * City itinerary as a row of elegant badges — one per stop, showing the city
 * and its nights ("Rome · 5 Nights"). Renders nothing when there are no named
 * stops. Shared by the list and grid cards so the badges read identically.
 */
export default function PackageCities({ cities }: PackageCitiesProps) {
  const stops = cities.filter((c) => c.name);
  if (!stops.length) return null;

  return (
    <div className={styles.cityBadges}>
      {stops.map((c, i) => {
        const nights = c.nights;
        return (
          <span key={`${c.name}-${i}`} className={styles.cityBadge}>
            <strong className="text-danger me-1">( {nights} )</strong>
            <span className={styles.cityName}>{c.name}</span>
          </span>
        );
      })}
    </div>
  );
}
